
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class VortexTunnelEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, width, height, time } = pc;
        const count = Math.floor((10 + layerIndex * 5) * (config.parallaxComplexity || 1.0));
        const speed = pc.config.parallaxSpeed * time;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const r = ((i / count) * Math.max(width, height) * 1.5) * (config.parallaxScale || 1.0);
                const rot = speed + i * 0.2;
                ctx.save();
                ctx.rotate(rot);
                ctx.beginPath();
                ctx.ellipse(0, 0, r, r * 0.5, 0, 0, Math.PI * 2);
                ctx.lineWidth = (2 / layerIndex) * (config.parallaxScale || 1.0);
                ctx.strokeStyle = pc.color;
                ctx.stroke();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
